import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import languages
import en from './translations/en.json';

i18n.use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en,
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },

    // allow keys to be phrases having `:`, `.`
    keySeparator: false,
    nsSeparator: false,
  });

export default i18n;
